<template>
    <li class="kit-info__step" v-if="$store.state.current && $store.state.step">
        <header :class="{pass: isPass(key), active: pos + 1 === $store.state.step, done: $store.getters.isKitStepEmpty(key), empty: !$store.getters.isKitStepEmpty(key) }" 
            @click="toggleProductsList()">
            <label>
                <i :class="!$store.getters.isKitStepEmpty(key) && isPass(key) ? 'fas fa-times' : 'fas fa-check'"></i>
            </label>
            <strong>{{ pos + 2 }}. {{ step.name }}</strong>

            <figure>
                <i class="fas" :class="toggle ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
            </figure>
        </header>
        <div v-show="toggle">
            <ul>
                <li v-for="(product, i) in cart" :key="i">
                    <StepProduct :product="product" :step="key" :key="i" />
                </li>
            </ul>
        </div>
    </li>
</template>

<script>
    import StepProduct from './StepProduct.vue';

    export default {
        name: 'InfoStep',
        props: ['step', 'className', 'pos'],
        components: {
            StepProduct
        },
        watch: {
            '$store.state.cart': {
                deep: true,
                handler(newVal) {

                    if (!this.$store.getters.isKitStepEmpty(this.key)) {
                        this.toggleList = false;
                        this.toggleManual = false;
                    }

                    if (this.$store.getters.isKitStepEmpty(this.key) && !this.toggleList && !this.toggleManual) {
                        this.toggleList = true;
                    }
                }
            }
        },
        data() {
            return {
                key: this.pos + 1,
                toggleList: false,
                toggleManual: false,
            };
        },
        computed: {
            toggle: function () {

                if (!this.$store.getters.isKitStepEmpty(this.key)) return false;

                if (!this.toggleManual && !this.toggleList) return true;

                return this.toggleList;
            },

            cart: function () {
                return this.$store.getters.getStepCart(this.key);
            },
        },
        methods: {
            toggleProductsList() {

                if (this.toggleManual) {
                    this.toggleList = !this.toggleList;
                }

                this.toggleManual = true;
            },

            isPass(key) {
                return this.$store.state.step > key || this.$store.getters.isOnOverview;
            }
        },
    }
</script>

<style lang="scss">
    .kit {
        &-info {
            &__step {
                ul {
                    padding: 0 10px;
                    padding-top: 12px;
                }
            }
        }
    }
</style>